module.exports = __webpack_public_path__ + "img/lbx.0dea0f97.png";